<template>
  <el-dialog
    class="setvisiable-dialog"
    title="设置"
    :visible.sync="$parent.setLocalVisiable"
    :close-on-click-modal="false"
    center
  >
    <div class="check-visiable-content">
      <div class="check-visiable-title">设置工作台是否显示品牌字体</div>
      <div class="check-list">
        <el-checkbox-group
          v-model="checklist"
          @change="setFontType(1)"
          :min="1"
          :max="2"
        >
          <div class="check-item">
            <el-checkbox label="1">显示默认字体库字体</el-checkbox>
          </div>

          <div class="check-item">
            <el-checkbox label="2">显示品牌字体</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
    </div>
    <div class="btn-wrap" slot="footer">
      <el-button  @click="$parent.setLocalVisiable = false">
        取消
      </el-button>
      <el-button type="primary" @click="setFontType(2)">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Brand } from "@/config/axios/new_api";
export default {
  props: {
    checklist: {
      type: Array,
      default: ["1"],
    },
  },
  methods: {
    setFontType(type) {
      let _this = this;
      if (this.checklist && this.checklist.length == 1) {
        if (this.checklist[0] == "") {
          this.checklist = ["1"];
          //console.log("没有选择")
        } else if (this.checklist[0] == 2) {
          //判断当前团队下是否有品牌字体
          Brand.brands({
            include: "fonts",
          }).then((res) => {
            //console.log(res)
            let fonts = res.data.current_team.fonts;
            //没有品牌字体进行吐司提示
            if (fonts && (!fonts.data || fonts.data.length == 0)) {
              Vue.prototype.$message.error("暂无品牌字体,请配置后在进行选择");
              _this.checklist = ["1"];
            }
            //有品牌字体进行字体设置
            if (fonts && fonts.data && fonts.data.length > 0) {
              _this.setFontTypeToServer(type);
            }
          });
        } else {
          this.setFontTypeToServer(type);
        }
      } else {
        this.setFontTypeToServer(type);
      }
    },
    setFontTypeToServer(type) {
      var _this = this;

      if (type == 2) {
        //二次弹窗提醒
        if(_this.checklist.length == 1){
          //关闭默认字体库
          if(!_this.checklist.includes("1")){
            this.closeType = '默认';
          }
          //关闭品牌字体库
          if(!_this.checklist.includes("2")){
            this.closeType = '品牌';
          }
          
          Vue.prototype
            .$confirm(`关闭${_this.closeType}字体库，工作台将无法使用${_this.closeType}字体，请谨慎操作！`, "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              customClass: "messageBoxClass",
              cancelButtonClass: "cancelbutton",
              confirmButtonClass: "confirmbutton",
              type: "warning",
            })
            .then(() => {
                Brand.setType(
                  {
                    team_id: _this.$parent.loginInfo.current_team_id,
                    types: _this.checklist.join(','),
                  }
                ).then((res) => {
                  if (res.status == 1) {
                    _this.$parent.setLocalVisiable = false;
                  }
                }).catch(err=>{
                  Vue.prototype.$message.error('服务出错')
                });
            })
            .catch(() => {
              return false;
            });
        }

        if(_this.checklist.length == 2){
          Brand.setType(
            {
              team_id: _this.$parent.loginInfo.current_team_id,
              types: _this.checklist.join(','),
            }
          ).then((res) => {
            if (res.status == 1) {
              _this.$parent.setLocalVisiable = false;
            }
          }).catch(err=>{
            Vue.prototype.$message.error('服务出错')
          });
        }

        
      }
    },
  },
};
</script>
